import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/commom/pic_success.png';
import _imports_1 from '@/assets/image/commom/pic_fail.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-70dcc152"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "callbackPupop"
};
var _hoisted_2 = {
  key: 0,
  "class": "content"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_4 = {
  "class": "text"
};
var _hoisted_5 = {
  key: 1,
  "class": "content"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_7 = {
  "class": "text"
};
var _hoisted_8 = {
  "class": "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    "model-value": $options.drawerShow,
    width: $options.isMobile ? '20.4rem' : '25.6rem',
    title: "",
    "class": "dialog-pop-box",
    top: "calc(50vh - 8rem)",
    "before-close": $options.handleClosesBox,
    "show-close": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
        color: "#000",
        type: "primary",
        onClick: $options.handleClosesBox
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('publish.close') + '(' + $data.second + 's)'), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    "default": _withCtx(function () {
      return [_ctx.web3Success ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('publish.successful')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('publish.failed')), 1)]))];
    }),
    _: 1
  }, 8, ["model-value", "width", "before-close"])]);
}